import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import NavibarStore from '@src/business-components/navibar/store';
import PageSwiperStore from '@src/components/swiper/page-swiper/store';
import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';
import AnchorNavStore from '@src/business-components/anchor-nav/store';
import { useEffect } from 'react';
import NewMechaScreenStore from '@src/pages/main/components/new-mech-screen/store';
import FirstScreenStore from '@src/pages/main/components/first-screen/store';
import PassportScreenStore from '@src/pages/main/components/passport-screen/store';
import HighlightScreenStore from '@src/pages/main/components/highlight-screen/store';
import FeatureScreenStore from '@src/pages/main/components/feature-screen/store';

class MainStore extends BaseStore {
  // comFooterStore = new ComFooterStore({
  //   mainStore: this,
  //   isWaterfall: false,
  //   gameCode: 'mechabreak',
  //   scrollToTop: () => {
  //     this.pageSwiperStore.baseSwiperStore.goTo(0);
  //     this.comFooterStore.isActive = false;
  //   }
  // });
  @observable bgmPlayState;

  @observable navibarStore = new NavibarStore();

  // 全屏swiper
  @observable
  pageSwiperStore = new PageSwiperStore({
    onPageSwiperChange: activeIndex => {
      this.anchorNavStore.activeIndex = activeIndex;
      this.navibarStore.setIsSticky(this.pageSwiperStore.activeIndex > 0);
    },
    effectMode: pageSwiperEffect.NORMAL
  });

  @observable
  anchorNavStore = new AnchorNavStore({
    onChange: index => {
      this.pageSwiperStore.baseSwiperStore.goTo(index);
    }
  });
  // 声明各个屏的store
  firstScreenStore = new FirstScreenStore({});
  newMechaScreenStore = new NewMechaScreenStore({});
  passportScreenStore = new PassportScreenStore({});
  highlightScreenStore = new HighlightScreenStore({});
  featureScreenStore = new FeatureScreenStore({});

  // 是否为最后一页
  get isFinalPage() {
    return this.pageSwiperStore.activeIndex >= this.pageSwiperStore.size - 1;
  }

  // 是否为第一页
  get isFirstPage() {
    return this.pageSwiperStore.activeIndex === 0;
  }

  handleScroll = e => {
    /**
     * 1. 如果已经滑动到最后一屏，此时再次滑动鼠标，则可以控制footer是否显示
     * 2. 如果不在最后一屏，且此时footer已经显示，此时向上滑动鼠标，则可以控制footer隐藏
     */
    if (!this.pageSwiperStore.finalPageTransitionEnd && !window.OMNI__COMMON__FOOTER.isVisible) {
      return;
    }

    window.OMNI__COMMON__FOOTER.isVisible = e.deltaY > 0;
  };

  showFooter = () => {
    window.OMNI__COMMON__FOOTER.isVisible = true;
  };

  logSize = () => {
    // 打印页面各类宽高属性
    console.log('window.innerWidth:', window.innerWidth);
    console.log('window.innerHeight:', window.innerHeight);
    console.log('document.documentElement.clientWidth:', document.documentElement.clientWidth);
    console.log('document.documentElement.clientHeight:', document.documentElement.clientHeight);
    console.log('document.documentElement.offsetWidth:', document.documentElement.offsetWidth);
    console.log('document.documentElement.offsetHeight:', document.documentElement.offsetHeight);
  };

  use() {
    super.use();

    useEffect(() => {
      window.OMNI__COMMON__FOOTER.to_top_handler = () => {
        this.pageSwiperStore.baseSwiperStore.goTo(0);
        window.OMNI__COMMON__FOOTER.isVisible = false;
      };
    }, []);

    useEffect(
      () => {
        const BgmStore = this.navibarStore?.bgm;
        if (!BgmStore) return;

        if (!this.firstScreenStore.videoPlayState && this.bgmPlayState) {
          if (BgmStore.playStateforClick) {
            BgmStore.handleChange(true);
          }
        } else {
          if (BgmStore.isPlaying) {
            this.bgmPlayState = true;
          }
          BgmStore.handleChange(false);
        }
      },
      [this.firstScreenStore.videoPlayState]
    );

    useMount(() => {
      window.init_OMNI__COMMON__FOOTER();

      // 底部版权栏的控制逻辑
      window.OMNI__COMMON__FOOTER.addEventListener('visibilityChange', isVisible => {
        clearTimeout(this.allowSwitchPageSwiperTimer);
        // 如果footer已经显示, 则禁止pageSwiper切换
        if (isVisible) {
          this.pageSwiperStore.allowSwitch = false;
        } else if (this.isFinalPage) {
          this.allowSwitchPageSwiperTimer = setTimeout(() => {
            this.pageSwiperStore.allowSwitch = true;
          }, 300);
        } else {
          this.pageSwiperStore.allowSwitch = true;
        }
      });

      window.addEventListener('wheel', this.handleScroll);
      return () => {
        window.removeEventListener('wheel', this.handleScroll);
      };
      //#endregion
    });

    useEffect(
      () => {
        this.firstScreenStore.isActive = this.pageSwiperStore.baseSwiperStore.activeIndex === 0;
        this.newMechaScreenStore.isActive = this.pageSwiperStore.baseSwiperStore.activeIndex === 1;
        this.passportScreenStore.isActive = this.pageSwiperStore.baseSwiperStore.activeIndex === 2;
        this.highlightScreenStore.isActive = this.pageSwiperStore.baseSwiperStore.activeIndex === 3;
        this.featureScreenStore.isActive = this.pageSwiperStore.baseSwiperStore.activeIndex === 4;
      },
      [this.pageSwiperStore.baseSwiperStore.activeIndex]
    );
  }
}

export default MainStore;
